import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AppInfo } from '@app/core/models/app-info';

@Component({
  selector: 'pcs-login-info',
  templateUrl: './login-info.component.html',
  styleUrls: ['./login-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginInfoComponent {
  @Input() appInfo: AppInfo;

  get version() {
    return this.appInfo.version;
  }

  get wsVersion() {
    return this.appInfo.wsVersion;
  }

  get releaseDate() {
    return this.appInfo.releaseDate;
  }
}
